/**
 * @module json-schema
 */
/** @pratico/json-schema */
import { get } from 'nested-property';

export function getValueByPath(data: any, dataPath: string) {
  return get(data, dataPath);
}
